import { z } from "zod";

export interface Project {
  id: string;
  name: string;

  visibility: string;

  studyCount: number;
  isArchived: boolean;

  createdAt: string;
  updatedAt: string;

  thumbnailName: string;
  username: string;
}

export interface HandleSaveArchiveValues {
  isArchived: boolean;
}
export interface HandleSaveEditValues {
  name: string;
  visibility: string;
}

/* Schema */
export const schema = z.object({
  name: z
    .string()
    .min(1, "Project name is required")
    .max(255, "Project name must be 255 characters or less")
    .refine((val) => val.trim().length > 0, "Project name is required"),
  visibility: z.union([z.boolean(), z.string()]),
  thumbnailName: z.string(),
});

export const editProjectschema = z.object({
  name: z
    .string()
    .min(1, "Project name is required")
    .max(255, "Project name must be 255 characters or less")
    .refine((val) => val.trim().length > 0, "Project name is required"),
  visibility: z.union([z.boolean(), z.string()]),
});

export const archiveProjectSchema = z.object({
  isArchived: z.boolean(),
});
